import { memo } from "react";

/**
 * Generic skeleton block.
 * @param {object} props
 * @param {number|string} [props.width]    - any CSS length; defaults to 100%
 * @param {number|string} [props.height]   - any CSS length; defaults to 16
 * @param {boolean} [props.circle]         - render as circle
 * @param {string} [props.className]       - extra classes
 * @param {object} [props.style]           - extra inline style
 */
function Skeleton({
    width = "100%",
    height = 16,
    circle = false,
    className = "",
    style,
}) {
    return (
        <div
            className={`skeleton ${circle ? "skeleton-circle" : ""} ${className}`}
            style={{
                display: "block",
                width,
                height,
                minHeight: height,
                ...style,
            }}
            aria-hidden="true"
        />
    );
}

export default memo(Skeleton);
